// Create Element.remove() function if not exist - for IE11
if (!('remove' in Element.prototype)) {
  Element.prototype.remove = function() {
      if (this.parentNode) {
          this.parentNode.removeChild(this);
      }
  };
}

//Copies nearest active HTML or SCSS to clipboard
var copyOverviewCode = function(element) {
  var codeToCopy = element.children('code').text();
  var elementArea = document.createElement('textarea');
  elementArea.setAttribute('id', 'copycode');
  elementArea.style.position = 'fixed';
  elementArea.style.bottom = 0;
  elementArea.style.left = 0;
  document.body.appendChild(elementArea);
  document.getElementById('copycode').value = codeToCopy;
  document.getElementById('copycode').select();
  document.execCommand('Copy');
  document.getElementById('copycode').remove();
}

$('.overview-copy').click(function() {
  var elementToCopy = $(this).parents('.code-functions').siblings('pre');
  var button = $(this);
  copyOverviewCode(elementToCopy);
  button.html('<i class="fas fa-copy"></i> Copied!');

  setTimeout(function() {
    button.html('<i class="fas fa-copy"></i> Copy Code');
  }, 2000);
});

var sassboxes = document.querySelectorAll('.language-css');

//Styles sass with prism after it's loaded into its code container
var sassboxStyler = function () {
  sassboxes.forEach(function(sassbox) {
    Prism.highlightElement(sassbox);
  });
};

//Generates the sass output for variables file, using the link in the download button
$('.code-wrap--get-sass').each(function() {
  var sassLink = $(this).find('.overview-download');
  var sassCodebox = $(this).find('code.language-css');
  var link = sassLink.attr('href');

  $.get(link, function(sassContent){
    sassCodebox.text(sassContent);
    sassboxStyler();
  });
});

//expand/shrink codebox
$('.overview-expand').click(function (){
  $(this).parents('.code-functions').siblings('.language-css').addClass('full');
  $(this).hide();
  $(this).siblings('.overview-shrink').show();
});

$('.overview-shrink').click(function (){
  $(this).parents('.code-functions').siblings('.language-css').removeClass('full');
  $(this).hide();
  $(this).siblings('.overview-expand').show();
});


// WEBPACK FOOTER //
// ./src/assets/fabricator/scripts/f-overview.js